const config = {
  applicationName: 'aw',
};

export default config;
